module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/642fb2f987bf8b54f176af13746c04cb.png";